import { stripCitationMarkers } from './string';
export function parseDeliverySpec(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
        return null;
    }
    const value = raw;
    const clean = (s) => stripCitationMarkers(s).trim();
    const intent = typeof value.intent === 'string' ? clean(value.intent) : '';
    if (!intent) {
        return null;
    }
    const rawBeats = value.beats;
    if (!Array.isArray(rawBeats) || rawBeats.length === 0) {
        return null;
    }
    const beats = [];
    for (const rawBeat of rawBeats) {
        if (!rawBeat || typeof rawBeat !== 'object') {
            return null;
        }
        const beat = rawBeat;
        const n = Number(beat.n);
        const share = Number(beat.share ?? beat.words);
        const summary = typeof beat.summary === 'string' ? clean(beat.summary) : '';
        const feel = typeof beat.feel === 'string' ? clean(beat.feel) : '';
        const rawHostState = typeof beat.hostState === 'string' ? beat.hostState : beat.host_state;
        const hostState = typeof rawHostState === 'string' ? clean(rawHostState) : '';
        const payoff = beat.payoff === 'minor' || beat.payoff === 'major' ? beat.payoff : null;
        if (!Number.isFinite(n) || !Number.isFinite(share) || share <= 0 || !summary) {
            return null;
        }
        beats.push({ n, summary, share, payoff, feel, hostState });
    }
    const specifics = Array.isArray(value.specifics)
        ? value.specifics
            .filter((s) => typeof s === 'string' && s.trim().length > 0)
            .map(clean)
        : undefined;
    const form = typeof value.form === 'string' && value.form.trim() ? value.form.trim() : undefined;
    const facts = Array.isArray(value.facts)
        ? value.facts
            .filter((f) => !!f && typeof f === 'object' && typeof f.fact === 'string' && f.fact.trim().length > 0)
            .map((f) => ({
            fact: clean(f.fact),
            confidence: f.confidence === 'settled' || f.confidence === 'contested' ? f.confidence : 'reported',
        }))
            .filter((f) => f.fact.length > 0)
        : undefined;
    return {
        intent,
        ...(form !== undefined && { form }),
        ...(specifics !== undefined && specifics.length > 0 && { specifics }),
        ...(facts !== undefined && facts.length > 0 && { facts }),
        beats,
    };
}
export function renderDeliveryPlan(spec, targetWords) {
    const lines = [];
    lines.push('## Delivery plan (follow this structure)');
    lines.push('');
    lines.push(`Overall intent: ${spec.intent}. Target ~${targetWords} words total.`);
    lines.push('');
    const payoffText = {
        minor: 'Minor payoff.',
        major: 'Major payoff.',
        none: 'No payoff yet.',
    };
    const totalShare = spec.beats.reduce((sum, beat) => sum + beat.share, 0);
    for (const beat of spec.beats) {
        const beatWords = Math.round((beat.share / totalShare) * targetWords);
        lines.push(`Beat ${beat.n} — ~${beatWords} words. ${beat.summary} Listener feel: ${beat.feel}. Hosts: ${beat.hostState}. ${payoffText[beat.payoff ?? 'none']}`);
        lines.push('');
    }
    if (spec.specifics && spec.specifics.length > 0) {
        lines.push(`Specifics to deploy intact (keep concrete, never dilute): ${spec.specifics.join('; ')}`);
        lines.push('');
    }
    lines.push('Spend the word budget as budgeted per beat — uneven is deliberate. Land payoffs where scheduled. The Hosts state per beat is how each speaker behaves there — PERFORM it through word choice, tone, and reactions; never speak the state words aloud or write them as stage directions. The final beat must resolve and land the way THIS plan\'s last beat describes — do not tack on the show\'s usual closing line or a generic wrap-up aphorism.');
    return lines.join('\n');
}
//# sourceMappingURL=delivery-spec.js.map